import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import {
  Page,
  PageDescription,
  PageSection,
  PageTitle,
} from "@/components/ui/layout/page/page";

import type { JSX } from "react";

const BillingAboutPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Sobre" align="center" />
      </HeaderRoot>
      <Page>
        <PageSection>
          <PageTitle>Entenda melhor o status da sua fatura</PageTitle>
          <PageDescription className="pt-4 flex flex-col gap-4">
            <p className="font-semibold">
              Aberto
              <li className="font-normal ml-6">
                A fatura ainda não foi fechada, novas movimentações serão incluídas nessa
                fatura até seu fechamento.
              </li>
            </p>
            <p className="font-semibold">
              Pendente
              <li className="font-normal ml-6">
                A fatura já foi fechada e está pendente de pagamento.
              </li>
            </p>
            <p className="font-semibold">
              Pago
              <li className="font-normal ml-6">A fatura está em dia.</li>
            </p>
            <p className="font-semibold">
              Em atraso
              <li className="font-normal ml-6">
                Não foi identificado o pagamento da fatura após a data do seu vencimento.
              </li>
            </p>
            <p className="font-semibold">
              Recusado
              <li className="font-normal ml-6">
                Houve uma tentativa de pagamento sem sucesso. Entre em contato com seu
                banco para entender os motivos ou tente novamente.
              </li>
            </p>
          </PageDescription>
        </PageSection>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/billing/about")({
  component: BillingAboutPage,
});
